import { useAuth } from "../../auth/hooks/useAuth";
import { useUserAccount } from "../userAccount/context";

export const useProfile = () => {
  const {
    profile: { data: { data: userProfile = null } = {} },
  } = useAuth();

  const { profile: { data: { data: authProfile = null } = {} } = {} } =
    useUserAccount();

  return userProfile || authProfile;
};
